class ReviewsCarousel extends HTMLElement {
  constructor() {
        super();
        this.swiperDom = this.querySelector(".reviews-swiper")
        this.mySwiper = new Swiper(this.swiperDom, {
            navigation: {
                nextEl: this.querySelector('.swiper-top .swiper-button-next'),
                prevEl: this.querySelector('.swiper-top .swiper-button-prev'),
            },
            breakpoints:{
                0:{
                    slidesPerView:1.2,
                    spaceBetween:10,
                },
                768:{
                    slidesPerView:3,
                    spaceBetween:20,
                },
            }
        })
    }
}

reg("reviews-carousel", ReviewsCarousel);